import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutElectronicAdvances extends Layout {
    advanceHistoryLabel: Label;
    electronicAdvancesSlideout: Panel;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    panelOtherCharges: Panel;
    panelTotalAdvances: Panel;
    panelTotalDeduction: Panel;
    sourceIssueAdvance: DataSource;
    sourceWireAdvanceQuickInfo: DataSource;
    switchDeduction: Switch;
    switchOrderPayeeAdvanceHistory: Switch;
    switchOther: Switch;
    switchZmitWire: Switch;
    tableOrderPayeeAdvanceHistory: Table;
    textboxAmount: Textbox;
    textboxDescr: Textbox;
    textboxDriverName: Textbox;
    textboxManifestId: Textbox;
    textboxMovementId: Textbox;
    textboxOrderId: Textbox;
    textboxOtherCharges: Textbox;
    textboxPayeeId: Textbox;
    textboxPayeeName: Textbox;
    textboxTotalAdvances: Textbox;
    textboxTotalDeductions: Textbox;
    textboxWirecode: Textbox;
}
